module.exports = __webpack_public_path__ + "static/banner2-7762ea870219837898824f9e97bbdc86.png";